<template>
    <div class="contain">
        <div class="searchInput bg-white f-b">
            <el-input placeholder="输入名称" v-model="bannerName" class="bannerNameInput">
                <el-button slot="append" icon="el-icon-search" type="primary" @click="getBannerList"></el-button>
            </el-input>
            <el-button type="primary" @click="addVisible = true">新增</el-button>
        </div>
        <div v-show="bannerList.length > 0">
            <div class="typeTag"> Mall Banner</div>
            <div class="showList f-b bg-white fw-w">
                <div v-for="item in bannerList" :key="item.id" class="item">
                    <div class="link">
                        {{ item.linkUrl}}
                    </div>
                    <div class="image f-c-c">
                        <el-image :src="item.imgUrl" :fit="'scale-down'" style="height: 200px"></el-image>
                    </div>
                    <div class="info f-b">
                        <div>
                            <div class="name">{{ item.bannerName }}</div>
                            <div class="time" style="color: #d4d3d3;font-size: 12px">{{ item.createDate | dateFormat}}</div>
                        </div>
                        <div>
                            <el-button type="text" @click="bannerManageEdit(item)" style="margin-right: 10px">编辑</el-button>
                            <el-popconfirm title="确定删除此banner吗？" @confirm="bannerManageDelete(item)">
                                <el-button slot="reference" type="text" style="color:#454545;">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </div>
                </div>
                <div class="item" style="border-color: transparent"></div>
            </div>
        </div>
        <div v-show="aggregationPageBannerList.length > 0">
            <div class="typeTag"> 聚合页 Banner</div>
            <div class="showList f-b bg-white fw-w">
                <div v-for="item in aggregationPageBannerList" :key="item.id" class="item">
                    <div class="link">
                        {{ item.linkUrl}}
                    </div>
                    <div class="image f-c-c">
                        <el-image :src="item.imgUrl" :fit="'scale-down'" style="height: 200px"></el-image>
                    </div>
                    <div class="info f-b">
                        <div>
                            <div class="name">{{ item.bannerName }}</div>
                            <div class="time" style="color: #d4d3d3;font-size: 12px">{{ item.createDate | dateFormat}}</div>
                        </div>
                        <div>
                            <el-button type="text" @click="bannerManageEdit(item)" style="margin-right: 10px">编辑</el-button>
                            <el-popconfirm title="确定删除此banner吗？" @confirm="bannerManageDelete(item)">
                                <el-button slot="reference" type="text" style="color:#454545;">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </div>
                </div>
                <div class="item" style="border-color: transparent"></div>
            </div>
        </div>
        
        <div class="donwList bg-white">
            <div>历史记录</div>
            <el-divider></el-divider>
            <div class="imageList">
                <div v-for="item in donwList" :key="item.id" class="f-b">
                    <div>
                        <el-image :src="item.imgUrl" style="width: 100px;height: 100px;margin-right: 10px"></el-image>
                        <el-button type="text" @click="bannerManageEdit(item, true)">恢复</el-button>
                    </div>
                    <div>{{ item.createDate | dateFormat}}</div>
                </div>
            </div>
        </div>
        <el-dialog :visible="addVisible" :title="dialogTitle" :before-close="addBeforeClose">
            <div class="addForm">
                <div class="upload">
                    <div v-if="addParams.imgUrl" class="f-c-c imageBox">
                        <el-image :src="addParams.imgUrl"  fit="fill" style="height: 100%"></el-image>
                        <el-button type="text" class="selectBtn" @click="uploadClick">重新选择</el-button>
                    </div>
                    <el-upload action="https://jsonplaceholder.typicode.com/posts/" :before-upload="beforeUpload" v-show="!addParams.imgUrl" ref="upload">
                        <div class="f-c-c uploadSelect" style="height: 300px;width: 100%" id="uploadCom">
                            <div class="content">
                                <div class="el-icon-plus" style="font-size: 40px;font-weight: bold"></div>
                                <div style="margin-bottom: 4px">上传banner图</div>
                                <div class="size" style="margin-bottom: 4px">上传不超过：2MB </div>
                                <div class="size" style="margin-bottom: 4px">图片尺寸为：876x376</div>
                            </div>
                        </div>
                    </el-upload>
                </div>
                <div class="form f">
                    <div class="label">名称:</div>
                    <el-input v-model="addParams.bannerName"></el-input>
                </div>
                <div class="form f">
                    <div class="label">跳转链接:</div>
                    <el-input v-model="addParams.linkUrl"></el-input>
                </div>
                <div class="form f">
                    <div class="label">图片排序:</div>
                    <el-input-number v-model="addParams.sort"></el-input-number>
                </div>
                <div class="form f">
                    <div class="label">类型:</div>
                    <div class="switch f--c">
                        <el-select v-model="addParams.type" size="medium" :style="{ width: '150px' }" placeholder="请选择" >
                            <el-option label="Mall Banner" :value="1" />
                            <el-option label="聚合页 Banner" :value="2" />
                        </el-select>
                    </div>
                </div>
                <div class="form f">
                    <div class="label">上架状态:</div>
                    <div class="switch f--c">
                         <el-switch
                            v-model="addParams.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :disabled="dialogMode === 'isRecovery'">
                        </el-switch>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer f-e">
                    <el-button @click="addBeforeClose">取消</el-button>
                    <el-button @click="addClick" type="primary">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// import vuedraggable from 'vuedraggable'
import API from '@/api'
export default {
    name: 'operation_bannerManage',
    components: {
        // vuedraggable
    },
    data() {
        return {
            bannerList: [],
            aggregationPageBannerList:[],
            bannerName: '',
            donwList: [],
            addVisible:false,
            addBannerList: [],
            addParams: {
                bannerName: undefined,
                linkUrl: undefined,
                imgUrl: undefined,
                type: undefined,
                status: true
            },
            signValue: undefined,
            dialogMode: 'add'
        }
    },
    async created() {
        this.getBannerList()
        const signValue = await API.signValue({directory: 'banner/'})
        this.signValue = signValue.data
    },
    computed: {
        dialogTitle() {
            const titleMap = {
                add: '新增',
                edit: '编辑',
                recovery: '恢复'
            }
            return titleMap[this.dialogMode]
        }
    },
    methods: {
        getBannerList() {
            API.getBannerList({bannerName: this.bannerName}).then(res=>{
                this.bannerList = res.data.showList
                this.aggregationPageBannerList = res.data.aggregationPageList
                this.donwList = res.data.donwList
            })
        },
        beforeUpload(file) {
            const params = new FormData()
            params.append('signValue', this.signValue)
            params.append('directory', 'banner/')
            params.append('fileList', file)
            API.uploadFile(params).then(res=>{
                this.addParams.imgUrl = res.data
            })
            return false
        },
        async addClick() {
            try {
                const params = Object.assign({}, this.addParams)
                params.status = params.status ? 1: 0
                if(this.dialogMode === 'add') {
                    const res = await API.bannerManageAdd(params)
                    if(res.code !== 10000) return this.$message.error(res.message)
                    this.$message.success(res.message)
                } else {
                    const res = await API.bannerManageUpdate(params)
                    if(res.code !== 10000) return this.$message.error(res.message)
                    this.$message.success(res.message)
                }
                this.addBeforeClose()
                this.getBannerList()
            } catch (error) {
                this.$message.error(error.data)
            }
        },
        addBeforeClose() {
            Object.keys(this.addParams).forEach(key=>{
                this.addParams[key] = undefined
            })
            this.addParams.status = true
            this.dialogMode = 'add'
            this.addVisible = false
        },
        async bannerManageEdit(item, isRecovery) {
            try {
                const res = await API.bannerManageEdit(item.id)
                this.addParams = Object.assign({}, res.data)
                this.addParams.status = !!this.addParams.status
                this.dialogMode = isRecovery ? 'recovery': 'edit'
                if(this.dialogMode === 'recovery') this.addParams.status = true
                this.addVisible = true
            } catch (error) {
                this.$message.error(error.data)
            }
        },
        async bannerManageDelete(item) {
            try {
                await API.bannerManageDelete(item.id)
                this.$message.success('删除成功')
                this.getBannerList()
            } catch (error) {
                this.$message.error(error.data)
            }
        },
        uploadClick() {
            const ele = document.querySelector('.el-upload')
            ele.children[1].click()
        }
    },
}
</script>

<style lang="scss" scoped>
.contain {
    margin: 4px 0 0 10px;
    min-width: 1400px;
    .topBreadcrumb {
        margin-bottom: 10px;
    }
    .searchInput {
        padding-bottom: 10px;
        padding: 10px;
        .bannerNameInput {
            width: 500px;
            /deep/.el-input__inner {
                border-top-left-radius: 20px;
                border-bottom-left-radius: 20px;
            }
            /deep/.el-input-group__append {
                border-top-right-radius: 20px !important;
                border-bottom-right-radius: 20px !important;
                background-color: #99c41c;
                color: #fff;
            }
        }
    }
    .showList {
        padding: 10px 10px 10px;
        .item {
            width: 33%;
            background-color: #fff;
            border: 1px solid #45454524;
            padding: 6px;
            .link {
                font-size: 12px;
                padding: 4px 0;
            }
            .image {
                width: 100%;
            }
        }
    }

    .typeTag {
        font-size: 20px;
        color:  #99c41c;
        padding: 10px;
        background-color: white;
    }
    .donwList {
        padding: 10px;
    }
    .addForm {
        padding: 0 20px;
        .upload {
            width: 100%;
            height: 300px;
            margin-bottom: 10px;
            /deep/.el-upload {
                width: 100%;
            }
            /deep/.uploadSelect {
                width: 100%;
                border: 1px solid #e2e2e2;
            }
            .imageBox {
                height: 300px;
                width: 100%;
                position: relative;
                .selectBtn {
                    position: absolute;
                    top: 90%;
                    left: 50%;
                    transform: translate(0, -50%);
                }
            }
        }
        .form {
            margin-bottom: 10px;
            .label {
                width: 80px;
                text-align: right;
                line-height: 40px;
                margin-right: 8px;
                font-size: 16px;
                font-weight: 400;
            }
        }
    }
}

</style>